import { base } from "./base";

const fr: base = {
  EMAIL: "Votre email",
  PASSWORD: "Votre mot de passe",
  WELCOME: "Bienvenue sur l'application prestataire d'Oiqia",
  LOGIN: "Se connecter",
  LOGOUT: "Se déconnecter",
  WARNING: "Attention",
  USER_NOT_FOUND: "Votre mot de passe ou votre email n'est pas correct",
  ERROR_LOGIN:
    "Tous les champs doivent être remplis et le mot de passe doit contenir au minimum 8 caractères dont une majuscule et un chiffre.",
  HEADER_SETTING: "Paramètres",
  HEADER_ACCOUNTING:"Mes Chiffres",
  HEADER_HOME: "Calendrier",
  HEADER_AGENDA: "Agenda",
  HEADER_INFO: "Info Perso",
  HEADER_DETAIL: "Appartement",
  HEADER_PROBLEM: "Incident",
  HEADER_HISTORY: "Résumé",
  HOME_ONGOING_TITLE: "Réservation en cours",
  HOME_EMPTY: "Aucune réservation en cours",
  HOME_ONWEEK: "Préstations sur la semaine",
  HOME_TITLE_SCREEN: "Détails du",
  HOME_CHECKIN: "CheckIn",
  HOME_CHECKOUT: "CheckOut",
  HOME_BILLING: "Facturations du mois",
  HOME_APPART: "Appartement",
  HOME_FIRSTNAME: "Prénom",
  HOME_LASTNAME: "Nom",
  HOME_LEAVE: "Départ du voyageur aujourd'hui",
  HOME_COME: "Arrivé",
  HOME_STATUS: "État",
  HOME_INCOMING: "Le voyageur arrive",
  HOME_ONGOING: "Voyageur présent",
  HOME_NO_CHECKIN: "Le voyageur ne s'est pas encore présenté",
  AGENDA_POP_TITLE: "Status de l'export",
  AGENDA_POP_CONTENT: "ont été ajoutés dans votre calendrier",
  AGENDA_POP_CONTENT_EMPTY: "Aucun évènement à ajouter dans votre calendrier",
  AGENDA_POP_BUTTON: "Continuer",
  DETAIL_TITLE: "Détails de l'appartement",
  DETAIL_TRAVELER_TITLE: "Informations Voyageur",
  DETAIL_TRAVELER_FIRSTNAME: "Prénom",
  DETAIL_TRAVELER_LASTNAME: "Nom",
  DETAIL_TRAVELER_PHONE: "Téléphone",
  DETAIL_TRAVELER_DEPARTURE: "Départ le",
  DETAIL_TRAVELER_ARRIVAL: "Arrivé le",
  DETAIL_APPART_TITLE: "Informations Appartement",
  DETAIL_APPART_WIFINAME: "Nom du wifi",
  DETAIL_APPART_WIFICODE: "Code du wifi",
  DETAIL_APPART_DESCRIPTION: "Description de l'appartement",
  DETAIL_APPART_EXTRA: "Information supplémentaire",
  DETAIL_APPART_ADDRESS: "Adresse",
  DETAIL_APPART_MAP: "Calculer l'itinéraire",
  DETAIL_PRICE_TITLE: "Facturation",
  DETAIL_PRICE_TOTAL: "Prix voyageur",
  DETAIL_PRICE_BASE: "Loyer",
  DETAIL_PRICE_CLEAN: "Ménage",
  DETAIL_PRICE_INTERVENTION: "Prix extra",
  DETAIL_PRICE_ORIGIN: "Origine",
  EVENT_TITLE: "Détails de l'évènement",
  EVENT_DETAIL_TITLE: "Nom de l'évènement",
  EVENT_DETAIL_DESC: "Description",
  EVENT_DETAIL_START: "De",
  EVENT_DETAIL_END: "À",
  EVENT_HISTORIQUE: "Historique",
  EVENT_STATUS_VALUE: "État",
  EVENT_STATUS_CREATEDAT: "Le",
  EVENT_STATUS_TITLE: "Informations de l'évènement",
  EVENT_STATUS_COMFIRM: "Confirmer l'évènement",
  EVENT_STATUS_CANCELED: "Refuser l'évènement",
  PURCHASE_DATE_TITLE: "Date d'achat :",
  EVENT_DETAIL_POP_TITLE: "Confirmation validée",
  EVENT_DETAIL_POP_CONTENT: "Votre confirmation a été prise en compte",
  EVENT_DETAIL_POP_BUTTON: "OK",
  EVENT_TODO_TITLE: "TodoList",
  EVENT_CHECKOUT_STATUS: "Statut :",
  EVENT_CHECKOUT_TITLE: "Checkout voyageur",
  EVENT_PROBLEM_TITLE: "Incident déclaré",
  EVENT_PROBLEM_EMPTY: "Aucun incident déclaré",
  EVENT_PROBLEM_BUTTON: "Déclarer un incident",
  EVENT_FINISH_BUTTON: "Finir la prestation",
  EVENT_EDIT_FINISH_BUTTON: "Sauvegarder les modifications",
  EVENT_DONE_TITLE: "Prestation finie",
  EVENT_DONE_EDIT_BUTTON: "Modifier l'évènement",
  EVENT_DONE_BUTTON: "Résumé de la prestation",
  EVENT_FINISH_PRESTA: "Finalisation de la prestation",
  EVENT_FINISH_DETAILS:
    "Afin de finaliser la prestation, merci de prendre au moins une photo de chaque pièce dans lesquelles vous êtes intervenu.",
  EVENT_VALIDATION_MISSING_PICTURE:
    "Merci de fournir au minimum une photo des lieux de l'intervention pour finir la prestation.",
  EVENT_FINISH_PICTURE_COMMENTARY: "Commentaires, remarques ...",
  PROBLEM_TITLE: "Déclarer un incident",
  PROBLEM_MODIFY_TITLE: "Modifier un incident",
  PROBLEM_PICTURE_TITLE: "Photos",
  PROBLEM_PICTURE_TAKE: "Prendre une photo",
  PROBLEM_PICTURE_PICK: "Photos de la galerie",
  PROBLEM_DESCRIPTION_TITLE: "Description",
  PROBLEM_TITLE_LABEL: "Nom de l'incident",
  PROBLEM_DESCRIPTION_LABEL: "Description",
  PROBLEM_PICTURES_EMPTY: "Aucune photo",
  INFO_SETTING: "Réglez vos paramètres",

  CHANGE_RESERVATION: "Changer de compte",
  CHOICE_LANG: "Choisissez votre langue",
  MSG_PERMISSION_LIBRARY:
    "Désolé, mais nous avons besoin des permissions pour accéder à votre répertoire.",
  MSG_PERMISSION_LIBRARY_DENIED:
    "Vous avez refusé l'accès à votre galerie photo, veuillez l'autoriser manuellement dans les paramètres de votre appareil.",
  TITLE_MSG_PERMISSION: "Demande de permission",
  TITLE_MSG_PERMISSION_DENIED: "Permissions non accordées",
  MSG_PERMISSION_CAMERA:
    "Désolé, mais nous avons besoin des permissions pour accéder à votre appareil photo.",
  MSG_PERMISSION_CAMERA_DENIED:
    "Vous avez refusé l'accès à votre caméra, veuillez l'autoriser manuellement dans les paramètres de votre appareil.",
  NOM_PRESTA: "Votre nom :",
  PRENOM_PRESTA: "Votre prénom :",
  TELEPHONE_PRESTA: "Votre téléphone :",
  EMAIL_PRESTA: "Votre Email :",
  DETAIL_BOOKING_PRICE_TITLE: "Informations Propriétaire",
  HEADER_ACHATS: "Achats",
  ACHATS_TITLE_DECLARE: "Déclarer des achats",
  ACHAT_PRODUCT_CONFIRM: "Valider ma déclaration d'achats",
  ACHAT_PROOF_MISSING:
    "Merci d'insérer une photo de la facture ou du ticket justifiant le prix et l'achat du produit.",
  ACHATS_PICTURE_TITLE:
    "Merci de prendre en photo du justificatif d'achat (facture et/ou ticket de caisse), avec le prix d'achat apparant.",
  ACHAT_PRODUCT_TITLE_TTC: "Prix TTC hors commission (obligatoire)",
  ACHAT_PRODUCT_TITLE_TVA5: "Dont TVA à 5.5% (obligatoire)",
  ACHAT_PRODUCT_TITLE_TVA10: "Dont TVA à 10% (obligatoire)",
  ACHAT_PRODUCT_TITLE_TVA20: "Dont TVA à 20% (obligatoire)",
  ACHATS_EXPLANATIONS: "Comment puis-je déclarer mes achats ?",
  ACHATS_EXPLANATIONS_TEXT:
    "Pour déclarer un achat vous devez sélectionner l'appartement concerné, puis indiquer le montant TTC hors commission (le calcul de la commission se fait automatiquement à la facturation). Finalement, reseignez une date d'achat en appuyant sur le bouton ci-dessous. Chaque champ est obligatoire.",
  ACHATS_SUCCESS: "Votre déclaration d'achats a été réalisée avec succès",
  ACHATS_TITLE_LIST: "Déclarations d'achats en cours de remboursement",
  ACHAT_TOTAL_PRICE_TTC: "Prix TTC :",
  ACHATS_REFRESHED: "Vos déclarations ont été mises à jour !",
  INCORRECT_CREDENTIALS: "Votre identifiant et/ou mot de passe est incorrect",
  COPIED: "Copie effectuée !",
  TEXT_COPIED: "Le mot de passe du Wifi a été copié dans le presse-papier",
  INFO_PERSO_TITLE: "Informations Personnelles",

  // Helpers
  HELP_TODO_INFO:
    "Cet encart vous permet de cocher les tâches réalisées sur l'appartement avant de finir la prestation (ces tâches sont obligatoires et nécessaires à la validation !)",
  HELP_INCIDENT_INFO:
    "Cet encart vous permet de déclarer un incident, en appuyant sur le bouton 'Déclarer un incident' puis, en prenant une photo et en décrivant le problème rencontré",
  HELP_CUSTOMER_INFOS:
    "Cet encart vous permet de consulter le prix payé par voyageur pour cette réservation",
  HELP_CHECKOUT_EVENT_INFO:
    "Cet encart vous permet de consulter les informations du checkout du voyageur, ses notations et le commentaire renseigné, le bouton 'Afficher les détails', permet d'accéder à la totalité des informations",
  HELP_TRAVELER_INFOS:
    "Cet encart vous permet de consulter l'identité ainsi que les coordonnées du voyageur", // TODO
  HELP_APPART_INFOS:
    "Cet encart vous permet de consulter les informations de l'appartement, vous pouvez cliquer sur le code du Wifi pour le copier",
  HELP_EVENT_INFO:
    "Cet encart vous permet de consulter les informations de l'évènement. Le nom, l'appartement concerné, la date de réalisation et l'état d'avancement.",
  HELP_INFOPERSO_INFO:
    "Cet encart vous permet de consulter vos informations personnelles, votre identité, vos coordonnées ainsi que vos rôles (Prestataire et/ou Propriétaire)",
  SHARE_EXPERIENCE_HELPER:
    "Cet encart contient un bouton vous permettant de nous envoyer un mail pour nous faire un retour sur votre experience utilisateur avec l'application Oiqia Services",
  /* "ACHAT_DONE": "Votre déclaration a bien été prise en compte !" */

  // qlError
  LOGIN_FAILED: "Connexion refusée",
  ERROR_NETWORK: "Merci de vérifier votre connexion internet.",

  //booking request
  HEADER_BOOKING: "Mes réservations",
  HEADER_BOOKING_REQUEST: "Demande de réservation",
  /* "BOOKING_REQUEST_LIST_TITLE": "Mes réservations à venir",
    "BOOKING_REQUEST_ADD_TITLE": "Demander une réservation",
    "BOOKING_REQUEST_ADD_TITLE_POP_TEXT": "Cet encart vous permet de réserver une de vos propriété sur la période demandée, cette demande sera traitée au plus vite par le service client Oiqia",
    "BOOKING_REQUEST_REASON": "Motif de la demande",
    "BOOKING_REQUEST_CONFIRM": "Valider ma demande",
    "BOOKING_REQUEST_APPART_LABEL": "Choix de l'appartement",
    "BOOKING_REQUEST_DATE_LABEL": "Choix des dates de réservation",
    "BOOKING_REQUEST_ADD_CHECK": "Je confirme que les informations indiquées correspondent à ma demande ?",
    "BOOKING_REQUEST_APPART_LABEL_ANDROID": "Cliquez ci-dessous pour changer d'appartement", */

  CHECKOUT_DONE: "Checkout réalisé",
  CHECKOUT_UNDONE: "Checkout non réalisé",
  CHECKOUT_RATING_CLEANNESS: "Note du ménage : ",
  CHECKOUT_RATING_OIQIA: "Note du support Oiqia : ",
  CHECKOUT_RATING_APPART: "Note de l'appartement : ",
  CHECKOUT_FEEDBACK: "Commentaire du voyageur : ",
  UNKNOWN: "Non renseigné",
  UNKNOWN_UNDONE: "Checkout non réalisé",

  CHECKOUT_UNDONE_TITLE_DETAILS: "Checkout non réalisé",
  CHECKOUT_UNDONE_BODY_DETAILS:
    "Aucune information à afficher car le voyageur n'a pas réalisé son checkout",
  UNKNOWN_UNDONE_TRAVELER: "Le voyageur n'a pas réalisé le checkout",

  SHARE_EXPERIENCE_TITLE: "Avis sur l'application Oiqia Services",
  SHARE_EXPERIENCE_MAIL_BUTTON: "Laisser un avis",
  SHARE_EXPERIENCE_FAILED:
    "Impossible d'ouvrir automatiquement votre application de mails, vous pouvez envoyer un mail manuellement à l'adresse suivante : serviceclient@oiqia.net",
  SHARE_EXPERIENCE_BODY:
    "L'application Oiqia Services est actuellement en version Beta, afin d'améliorer l'experience utilisateur, nous vous invitons à faire un retour sur votre expérience par mail !",
  ACHATS_NO_APPART_LINKED: "Vous n'êtes lié à aucun appartement",

  EVENT_REDUCE_BUTTON_TEXT: "Cacher les détails",
  EVENT_DEPLOY_BUTTON_TEXT: "Afficher les détails",

  ACHAT_SEE_BILL: "Voir le ticket",
  APPART_SELECTION_TITLE: "Appartement :",
  PRICE_INPUT_TITLE: "Prix TTC (hors commission) :",

  ACHAT_WRONG_PARAM_TITLE: "Attention !",
  ACHAT_WRONG_PARAM_BODY:
    "Il semblerait que vous ayez mal rempli le formulaire. Assurez-vous d'indiquer un prix TTC d'achat strictement en chiffre (sans devise €, $ ...) et au moins une photo du justificatif d'achats ",

  ACHATS_LIST_EXPLANATION_BODY:
    "Cet encart vous permet de voir vos déclarations d'achats qui n'ont pas encore été remboursées",

  RERMOVE_ACHAT_CONFIRM_TITLE: "Confirmation de suppression",
  RERMOVE_ACHAT_CONFIRM_BODY:
    "Êtes-vous sûr de vouloir supprimer cette déclaration d'achat ?",
  RERMOVE_ACHAT_CONFIRM_YES: "Confirmer",
  RERMOVE_ACHAT_CONFIRM_FALSE: "Annuler",
  RERMOVE_PICTURE_CONFIRM_BODY:
    "Êtes-vous sûr de vouloir supprimer cette photo ?",

  CHECKOUT_PICTURE_INCIDENT: "Incident déclaré par le voyageur :",
  CHECKOUT_DONE_INCIDENT: "Checkout réalisé (avec incident ⚠)",
  CHECKOUT_INCIDENT_DESCRIPTION_NULL: "Aucune description",
  EVENT_PROBLEM_PICTURE_EMPTY: "Aucune photo déclarée",

  VALIDATION_PICTURE_TITLE: "Photo(s) à l'issue de l'évènement",
  VALIDATION_PICTURE_EMPTY: "Aucune photo à afficher",
  VALIDATION_PICTURE_OUT_OF_DATE: "Photo invalide",
  VALIDATION_PICTURE_OUT_OF_DATE_CONTENT:
    "Cette photo est trop ancienne pour être utilisée comme validation, veuillez ré-essayer avec une photo plus récente",
  VALIDATION_PICTURE_MISSING: "Oups ...",
  VALIDATION_PICTURE_MISSING_BODY:
    "Au moins une photo de validation est nécessaire pour modifier cet évènement, veuillez ré-essayer.",
  VALIDATION_PICTURE_SUCCESS: "Succès !",
  VALIDATION_PICTURE_SUCCESS_BODY: "Évènement mis à jour avec succès !",
  OUT_OF_RANGE_EDITION:
    "Un évènement peut être uniquement modifié le jour de sa réalisation.",
  EVENT_VALIDATION_NOT_SAME_DAY_TITLE: "Attention !",
  EVENT_VALIDATION_NOT_SAME_DAY:
    "Vous vous apprêtez à valider un évènement en dehors de son jour de réalisation, voulez-vous tout de même confirmer cet évènement ?",
  CANCEL: "Annuler",
  VALIDATE: "Valider",
  ERROR: "Erreur !",
  TITLE_DESC_MISSING_PROBLEM:
    "Merci d'indiquer le titre ainsi que la description de votre problème, nous vous invitons également à ajouter des photos illustratives.",
  EXPIRED_TOKEN: "Session expirée",
  EXPIRED_TOKEN_TEXT:
    "Votre session a expiré vous allez être redirigé(e) vers la page de connexion",
  UNKOWN_ERROR_TITLE: "Une erreur innatendue est survenue",
  UNKOWN_ERROR_DESCRIPTION:
    "Un problème inattendu est survenu. Veuillez réessayer plus tard.",
};

export default fr;
